import React, { useState } from 'react';
import { Button, CircularProgress, Typography } from '@mui/material';
import { apiCall } from '../../utils/fetchAPI';

/**
 * "Je n'ai pas reçu l'email": asks for a new confirmation link.
 *
 * The API answers the same whether or not the address has an account waiting,
 * so there is nothing to tell apart here either: once asked, the button says
 * it is sent. Only a refusal to send at all — too many tries — is shown.
 */
function ResendConfirmation({ email }) {
  const [state, setState] = useState('idle');
  const [error, setError] = useState('');

  const resend = async () => {
    setState('sending');
    setError('');

    try {
      const response = await apiCall('/auth/resend-confirmation', {
        method: 'POST',
        body: JSON.stringify({ email }),
      });

      if (!response.ok) {
        const data = await response.json().catch(() => ({}));
        setError(data.error || 'L’email n’a pas pu être renvoyé. Réessayez plus tard.');
        setState('idle');
        return;
      }

      setState('sent');
    } catch {
      setError('L’email n’a pas pu être renvoyé. Réessayez plus tard.');
      setState('idle');
    }
  };

  if ('sent' === state) {
    return (
      <Typography variant="body2" role="status">
        Un nouveau lien vient de partir. Pensez à regarder dans les indésirables.
      </Typography>
    );
  }

  return (
    <>
      <Button variant="outlined" onClick={resend} disabled={!email || 'sending' === state}>
        {'sending' === state ? (
          <>
            <CircularProgress size={18} sx={{ mr: 1.5, color: 'inherit' }} />
            Envoi…
          </>
        ) : (
          'Renvoyer l’email de confirmation'
        )}
      </Button>
      {error && (
        <Typography variant="body2" color="error" role="alert">
          {error}
        </Typography>
      )}
    </>
  );
}

export default ResendConfirmation;
